<ul class="nav nav-tabs justify-content-start">
  <li class="nav-item" *ngIf="authService.hasRole(TipoUsuario.SEGURIDADTABLAS, TipoUsuario.SOPORTE)">
    <a class="nav-link" routerLink="abmAsignacion" routerLinkActive="active"><b>ABM de asignación</b></a>
  </li>
  <li  class="nav-item">
    <a class="nav-link" routerLink="listadoAsignados" [queryParams]="{param: ListadoAsignaciones.Pendientes}" routerLinkActive="active"><b>Usuarios pendientes</b></a>
  </li>
  <li  class="nav-item">
    <a class="nav-link" routerLink="listadoAsignados" [queryParams]="{param: ListadoAsignaciones.Manual}" routerLinkActive="active"><b>Asignación manual de usuarios</b></a>
  </li>
  <li  class="nav-item">
    <a class="nav-link" routerLink="listadoAsignados" [queryParams]="{param: ListadoAsignaciones.Asignados}" routerLinkActive="active"><b>Usuarios asignados</b></a>
  </li>
</ul>
<router-outlet></router-outlet>